module.exports = __webpack_public_path__ + "img/piktogram.e8f24cdc.png";